import sendRequest from "../fetch"
import Qs from 'qs'
import { cleanParams, getApi } from "@/utils";



// 修改个人信息
export const editAdmin = (params) => {
  let _params = cleanParams(params);
  return sendRequest(getApi() + "system/user/updateProfile", {
    data: _params,
    method: "POST",
  });
};

// 修改密码
export const resetPassword = (params) => {
  let _params = cleanParams(params);
  return sendRequest(getApi() + "system/user/updatePwd", {
    data: Qs.stringify(_params),
    method: "POST",
  });
};



// WEBPACK FOOTER //
// ./src/fetch/api/admin.js